import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { URL_WORKER } from '../../../helpers/helpers';
import "../../Curso/styles/ShareCertificate.scss";
// Usa el worker localmente
pdfjs.GlobalWorkerOptions.workerSrc = URL_WORKER;

function PDFViewer({ pdfUrl, onDocumentLoadError, scale }) {
    return (
        <Document 
          file={pdfUrl} 
          onDocumentLoadError={onDocumentLoadError}
        >
          <Page pageNumber={1} scale={scale} renderMode="svg" />
        </Document>
    );
  };

export default PDFViewer;
